import benjyLogo from '../../../../../assets/img/manvar-logo.png'
import jsPDF from "jspdf";
import 'jspdf-autotable';



export const useHelpers = () => {

    const defaultFontSize = 10
    const titleFontSize = 25
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const convertToFloat = (formattedNumber) => {

        if (typeof formattedNumber !== 'string') {
            // console.error('El valor no es un string válido:', formattedNumber);
            return 0; // Retorna 0 como valor predeterminado
        }

        const cleanedValue = formattedNumber.replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);
        return isNaN(floatValue) ? 0 : floatValue; // Retorna 0 si no es un número válido
    };

    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes

        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const getCurrentTime = () => {
        const now = new Date();
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    const extractIdVehicle = (input) => {
        const pattern = /^VH/; // Define el patrón que debe coincidir

        if (!pattern.test(input)) {
            return {
                statusCode: false,
                statusMessage: "El texto no coincide con el patrón requerido 'VHXXX'.",
                idcredito: null
            };
        }

        const numberString = input.replace(pattern, ''); // Elimina el patrón de la cadena

        if (numberString === '') {
            return {
                statusCode: false,
                statusMessage: "Numero de identificar incorrecto",
                idcredito: null
            };
        }

        const number = parseInt(numberString, 10); // Convierte el resultado en un número entero

        if (isNaN(number)) {
            return {
                statusCode: false,
                statusMessage: "Numero de identificar incorrecto.",
                idcredito: null
            };
        }

        return {
            statusCode: true,
            statusMessage: "Conversión exitosa.",
            idcredito: number
        };
    };

    function compareDates(date1, date2) {
        // Convertimos las fechas en objetos Date
        const d1 = new Date(date1);
        const d2 = new Date(date2);

        // Comparamos el año y el mes
        const sameMonthAndYear = d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();

        return sameMonthAndYear;
    }

    const calculateLateInterest = (payment, previousOutstandingBalance, dias_atraso, dias_atraso_ultimo_pago) => {
        const paymentFloat = parseFloat(payment);
        const previousOutstandingBalanceFloat = parseFloat(previousOutstandingBalance)

        if (previousOutstandingBalanceFloat > 0) {

            // const mora = calculateMora(payment, previousOutstandingBalance, dias_atraso, dias_atraso_ultimo_pago)
            // const saldo_total = previousOutstandingBalanceFloat + mora 
            return (paymentFloat + previousOutstandingBalanceFloat) * 0.10;
        }
        return (paymentFloat) * 0.10;
    };

    const calculateMora = (cuota_pagar, saldo_cuota_anterior, dias_atraso, dias_atraso_ultimo_pago) => {
        let dias_atraso_temp
        (saldo_cuota_anterior > 0) && (dias_atraso > 0) ? dias_atraso_temp = dias_atraso_ultimo_pago : dias_atraso_temp = dias_atraso

        const interes_mora = calculateLateInterest(cuota_pagar, saldo_cuota_anterior)
        const pago_dias_atraso = (parseInt(dias_atraso_temp) * 10)

        return (interes_mora + pago_dias_atraso)
    }

    const enableButtonAbono = (fecha_actual, fecha_pago, enable, total_pagar_f, total_abonado) => {

        const fecha_actual_date = new Date(fecha_actual)
        const fecha_pago_date = new Date(fecha_pago);
        const total_pagar_f_float = parseFloat(total_pagar_f);
        const total_abonado_float = parseFloat(total_abonado);

        if ((fecha_pago_date < fecha_actual_date)) return true

        if (!enable) return true

        if ((total_pagar_f_float - total_abonado_float) > 0) return true

        // if(total_pagar_f > 0) return true

        return false
    }

    const getPreviousMonthDate = (dateString) => {
        const [year, month, day] = dateString.split('-').map(Number); // Divide la fecha y convierte a números
        const date = new Date(year, month - 1, day); // Crea un objeto de fecha
        date.setMonth(date.getMonth() - 1); // Resta un mes

        // Ajusta si la fecha cambia por días fuera del rango del mes (ejemplo: 31 de febrero)
        if (date.getDate() !== day) {
            date.setDate(0); // Establece al último día del mes anterior si ocurre desbordamiento
        }

        // Formatea la nueva fecha en 'YYYY-MM-DD'
        const newYear = date.getFullYear();
        const newMonth = date.getMonth() + 1;
        const newDay = date.getDate();

        return `${newYear}-${newMonth < 10 ? `0${newMonth}` : newMonth}-${newDay < 10 ? `0${newDay}` : newDay}`;
    };

    //SECCION PARA GENERAR RECIBO DE PAGO

    const _drawHeaderPaymentTicket = (docPdf, data, posY) => {

        // Marco 
        docPdf.rect(10, 10, 260, 195); // x=10, y=20, ancho=100, alto=50

        // Logo
        const imgWidth = 50;
        const imgHeight = 30;
        docPdf.addImage(benjyLogo, 'PNG', 20, posY - 15, imgWidth, imgHeight);

        // Membrete principal
        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(titleFontSize);
        docPdf.text('GRUPO MANVAR S.A.', 140, posY, { align: 'center' }); // Centrado
        docPdf.setFontSize(defaultFontSize);

        posY += 5

        docPdf.setFont("helvetica", "normal");
        docPdf.text('KILÓMETRO 59.5 CARRETERA A TAXISCO, ESCUINTLA, ESCUINTLA', 140, posY, { align: 'center' });
        docPdf.text('TELEFONO: 2458-1568 EXTENSION 1', 140, posY + 5, { align: 'center' });

        posY += 20

        // Fecha
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 62, 5, 'F');
        docPdf.rect(20, posY, 95, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('FECHA Y HORA DE IMPRESION ', 25, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(`${getCurrentDate()} ${getCurrentTime()}`, 83, posY + 4, { align: 'left' });

        // Hora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(115, posY, 20, 5, 'F');
        docPdf.rect(115, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CUOTA', 118, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.fecha_cuota, 140, posY + 4, { align: 'left' });
        
        // Estado
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ESTADO', 185, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_check, 220, posY + 4, { align: 'left' });

        posY += 10

        // Cliente
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 160, 5); //240
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CLIENTE', 25, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.datos_cliente, 58, posY + 4, { align: 'left' });

        // Por
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('POR Q', 185, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_quetzales.toLocaleString(), 220, posY + 4, { align: 'left' });

        posY += 5

        // Concepto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(20, posY, 160, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CONCEPTO', 25, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text('DEPOSITO POR PAGO DE CREDITO', 58, posY + 4, { align: 'left' });

        // Fecha de pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(180, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('F. PAGO', 185, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.deposito_fecha, 220, posY + 4, { align: 'left' });

    }

    const _drawIdentifiersPaymentTicket = (docPdf, data, posY) => {

        docPdf.setFont("helvetica", "bold");
        docPdf.setFontSize(defaultFontSize);
        docPdf.text(`CREDITO ${data.contrato_codigo}`, 215, posY);
        docPdf.text(`RECIBO NO. ${data.idmovimiento}`, 215, posY + 5);

    }

    const _drawInfoPaymentTicket = (docPdf, data, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TIPO', 23, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_tipo, 45, posY + 4, { align: 'left' });

        // Monto
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONTO', 70, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_monto, 92, posY + 4, { align: 'left' });

        posY += 5

        // Moneda
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MONEDA', 23, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.deposito_moneda, 45, posY + 4, { align: 'left' });

        // Tipo cambio
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAMBIO', 70, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(String(data.deposito_tipo_cambio), 92, posY + 4, { align: 'left' });

        posY += 5

        // Total Queztales
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL Q.', 23, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_quetzales, 45, posY + 4, { align: 'left' });

        // Total Dolares
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('TOTAL $.', 70, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.movimiento_dolares, 92, posY + 4, { align: 'left' });
        
        posY += 15
        
        // Numero de boleta
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BOLETA', 23, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.boleta_numero || '---', 45, posY + 4, { align: 'left' });

        // Referencia ACH
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(67, posY, 23, 5, 'F');
        docPdf.rect(67, posY, 47, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('ACH', 70, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.aprobacion_referencia_ach || '---', 92, posY + 4, { align: 'left' });
        
        posY += 10

        // Caja
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 154, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('CAJA', 23, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.descripcion_caja || '---', 45, posY + 4, { align: 'left' });

        posY += 5

        // Banco
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(20, posY, 23, 5, 'F');
        docPdf.rect(20, posY, 154, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('BANCO', 23, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.descripcion_banco || '---', 45, posY + 4, { align: 'left' });


    }

    const _drawBalanceInfoPaymentTicket = (docPdf, data, posY) => {

        // Saldos Atrasados
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(120, posY, 30, 5, 'F');
        docPdf.rect(120, posY, 54, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('SALDOS ATRAS.', 122, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.pago_saldo_anterior, 152, posY + 4, { align: 'left' });

        posY += 5

       // Mora
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(120, posY, 30, 5, 'F');
        docPdf.rect(120, posY, 54, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('MORA', 122, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.pago_mora, 152, posY + 4, { align: 'left' });

        posY += 5

        // Gastos
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(120, posY, 30, 5, 'F');
        docPdf.rect(120, posY, 54, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('GASTOS', 122, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.pago_gastos, 152, posY + 4, { align: 'left' });

        posY += 5

        // Intereses
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(120, posY, 30, 5, 'F');
        docPdf.rect(120, posY, 54, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('INTERESES', 122, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.pago_intereses, 152, posY + 4, { align: 'left' });

        posY += 5

        // Amortizacion
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(120, posY, 30, 5, 'F');
        docPdf.rect(120, posY, 54, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('AMORTIZACION', 122, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.pago_amortizacion, 152, posY + 4, { align: 'left' });

        posY += 5

        // Abono Capital
        docPdf.setFillColor(230, 230, 230); // RGB gris
        docPdf.rect(120, posY, 30, 5, 'F');
        docPdf.rect(120, posY, 54, 5);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('A. CAPITAL', 122, posY + 4, { align: 'left' });
        docPdf.setFont("helvetica", "normal");
        docPdf.text(data.pago_abono_capital, 152, posY + 4, { align: 'left' });
    }

    const _drawObservationsPaymentTicket = (docPdf, data, justifyTextBox, posY) => {

        // Info Pago
        docPdf.setFillColor(230, 230, 230); // RGB gris
        // docPdf.rect(20, posY, 35, 5, 'F');
        docPdf.rect(180, posY, 80, 70);
        docPdf.setFont("helvetica", "bold");
        docPdf.text('OBSERVACIONES', 183, posY + 4, { align: 'left' });

        posY += 5
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.deposito_observaciones || '', 181, posY + 4, 80, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

        posY += 35
        docPdf.setFont("helvetica", "normal");
        justifyTextBox(docPdf, data.aprobacion_observaciones || '', 181, posY + 4, 80, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })

    }

    const _drawFooterPaymentTicket = (docPdf, data, justifyTextBox, posY) => {

        docPdf.line(20, posY, 90, posY);
        docPdf.text('FIRMA AUTORIZADA', 40, posY + 7, { align: 'left' });
        docPdf.text('SELLO', 125, posY + 4, { align: 'left' });
        
        posY += 20
        docPdf.setFont("helvetica", "normal");
        const text = '*NOTA:* Por cheque rechazado se cobrará en concepto de gastos administrativos: Q150.00 cheques en Quetzales y $20.00 cheques en dólares, quedando anulado este recibo de inmediato. INTERESES Y MORA: Se cobrará 10% sobre la cuota a vigente a cancelar y un monto de Q10.00 diarios en concepto de mora, hasta hacer efectivo el pago correspondiente, este monto podrá variar conforme al contrato vigente o conforme a políticas internas sin previo aviso. Plazo Extemporáneo: Se cobrará Q1,000.00 por me adicional después de vencido el plazo contractual o estipulado por cada negocio.'
        justifyTextBox(docPdf, text, 20, posY, 240, {
            fontSize: defaultFontSize,
            fontName: 'helvetica',
            lineSpacing: 5
        })
    }

    const drawPaymentTicket = (pdfManager, data) => {

        const { justifyTextBox } = pdfManager
        const pdfLandscapeDoc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'letter',
        });

        console.log('drawPaymentTicket ----- ', data)

        _drawHeaderPaymentTicket(pdfLandscapeDoc, data, 30)
        _drawIdentifiersPaymentTicket(pdfLandscapeDoc, data, 30)
        _drawInfoPaymentTicket(pdfLandscapeDoc, data, 85)
        _drawBalanceInfoPaymentTicket(pdfLandscapeDoc, data, 85)
        _drawObservationsPaymentTicket(pdfLandscapeDoc, data, justifyTextBox, 85)
        _drawFooterPaymentTicket(pdfLandscapeDoc, data, justifyTextBox, 155)

        pdfLandscapeDoc.save(`RECIBO PAGO VEHICULO - ${data.contrato_codigo}.pdf`);
    }

    return Object.freeze({
        getCurrentDate,
        extractIdVehicle,
        compareDates,
        calculateLateInterest,
        calculateMora,
        enableButtonAbono,
        convertToFloat,
        numberFormatter,
        getPreviousMonthDate,
        drawPaymentTicket
    })
}